import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Box } from "../../../../../Box/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { Icon } from "../../../../../Icon/index.js";
import { useHeight } from "../hooks/index.js";
const VideoFailed = (t0)=>{
    const $ = c(5);
    const { height, width } = t0;
    const defaultHeight = useHeight();
    const t1 = height || defaultHeight;
    const t2 = width || "100%";
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ jsx(Icon, {
            name: "error_circle_fill_gray",
            size: "20",
            color: "text.light.tertirary"
        });
        t4 = /*#__PURE__*/ jsx(Typography, {
            variant: "subtitle1",
            color: "text.light.primary",
            children: "Не удалось загрузить видео"
        });
        $[0] = t3;
        $[1] = t4;
    } else {
        t3 = $[0];
        t4 = $[1];
    }
    let t5;
    if ($[2] !== t1 || $[3] !== t2) {
        t5 = /*#__PURE__*/ jsxs(Box, {
            bgcolor: "bg.greyscale.primary",
            height: t1,
            width: t2,
            maxWidth: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "8",
            radius: "s",
            children: [
                t3,
                t4
            ]
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
};
export { VideoFailed };
